<template>
  <div class="layout-options-setting-dialog">
    <template v-if="curNav !== 0">
      <div class="navBackBox" @click="changeNav(0, false)">
        <i class="navBackIcon icon-portal-arrows-left"></i>
        <span class="navBackTitle">{{ navName }}</span>
      </div>
    </template>
    <numberConfig :configData="numberConfig"  v-if="curNav === 1 && settingStatus === 'sub'"></numberConfig>
    <unitConfig :configData="unitConfig"  v-if="curNav === 2 && settingStatus === 'sub'"></unitConfig>
    <div class="content-group-default" v-if="settingStatus !== 'sub'">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="内容" name="1">
          <div class="navBox" @click="changeNav(1, true, '数字')">
            <span class="navTitle">数字</span>
            <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
          </div>
          <div class="navBox mt12" @click="changeNav(2, true, '单位')">
            <span class="navTitle">单位</span>
            <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
          </div>
        </el-collapse-item>
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <!-- <el-collapse-item title="位置" name="2">
          <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="position"/>
        </el-collapse-item> -->
      </el-collapse>
      <mainSetting :configData="mainConfig" v-if="settingStatus !== 'sub'"></mainSetting>
      <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="12">
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import mainSetting from "./configs/mainConfig"
import numberConfig from "./configs/numberConfig"
import unitConfig from "./configs/unitConfig"
export default {
  name: "countdown-options-setting",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, TextSettingComplex, elementPluginSetting, mainSetting, numberConfig, unitConfig },
  props: { options: Object },
  data() {
    return {
      defaultImage: require("assets/images/image_placeholder.png"),
      this1: this,
      collapseActiveNames: ["1", "2"],
      activeNames: ["1", "2"],
      allCollapseNames: ["3", "4", "5", "6"],
      activeType: 1,
      explainDialog: false,
      explainImgSrc: "",
      explainVideoSrc: "",
      navName: '',
      curNav: 0
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    mainConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "mainConfig", "mainConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "mainConfig", false)
      }
    },
    unitConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "unitConfig", "unitConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "unitConfig", false)
      }
    },
    numberConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "numberConfig", "numberConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "numberConfig", false)
      }
    },
    settingStatus() {
      return this.curNav === 0 ? 'main' : 'sub'
    },
    ids() {
      return this.$store.state.states.activeID
    },
    width: {
      get() {
        return this.options.width || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    }
  },
  methods: {
    changeNav(val, flag, subNavName) {
      this.curNav = val
      this.navName = subNavName
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
      if (val === 0) {
        this.$eventBus.$emit('enableOpen', this.ids)
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    explainDialogClick() {
      this.explainDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }
  .navLabel{
    color: var(--thirdTextColor);
    display: flex;
  }
  .navIcon {
    font-size: 20px;
  }
  &:hover{
    cursor: pointer;
  }
}
.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .navBackIcon {
    font-size: 24px;
  }
  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}
</style>
